export * from "./src/http-loader";



//////////////////
// WEBPACK FOOTER
// /Users/ggueret/Desktop/Personnel/Angular/ares-app/~/@ngx-translate/http-loader/index.js
// module id = ../../../../@ngx-translate/http-loader/index.js
// module chunks = 3